/*
  LightBox 插件
  使用方法：LightBox(url)
  url 图片链接
*/

import LightBox from './src/main.js'
export default LightBox



// WEBPACK FOOTER //
// ./src/plugins/lightbox/index.js